import React, { Component } from 'react';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import countries from './countries';
import { Content } from '../infrastructure/content';
import { CountryUtil } from './utils/countryUtils';
export class Nationality extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: countries.map(country => ({
        id: country.code || country.name,
        labelText: country.nationality || country.name
      }))
    };
    this.getOptions = this.getOptions.bind(this);
  }

  getOptions() {
    if (this.props.removeCountries && this.props.removeCountries.length > 0) {
      return CountryUtil.filterCountres(countries, this.props.removeCountries, 'nationality');
    }
    return this.state.options;
  }

  render() {
    const { values, onChange } = this.props;
    return (
      <Content>
        {() => (
          <GenericSelect
            id="nationalityOther"
            {...this.props}
            items={this.getOptions()}
            selectedId={!values.nationalityOther ? null : values.nationalityOther}
            onChange={selectedId => {
              onChange(selectedId);
            }}
          />
        )}
      </Content>
    );
  }
}

export default Nationality;
